import { dateTime } from '../../../../shared/packages/dateTime';

export class AcceptanceDesk {
  constructor(desk) {
    this._payload = desk;
    this._hasActionsByDay = new Map();
    this._periods = [];

    desk.deskSettingWorkingDates.forEach((setting) => {
      setting.intervalsDates.forEach(({ fromDate, toDate }) => {
        this._periods.push(dateTime(fromDate), dateTime(toDate));
      });
    });
  }

  get id() {
    return this._payload.deskId;
  }

  get name() {
    return this._payload.deskName;
  }

  get payload() {
    return this._payload;
  }

  _hasActions(date, isoDateStr) {
    let result = this._hasActionsByDay.get(isoDateStr);

    if (result === undefined) {
      for (let i = 0; i < this._periods.length; i += 2) {
        if (
          date.isBetween(this._periods[i], this._periods[i + 1], 'day', '[]')
        ) {
          result = true;
          break;
        }
      }

      result = Boolean(result);
      this._hasActionsByDay.set(isoDateStr, result);
    }

    return result;
  }
}
